import baseURL from "../config";
import {
    Box,
    Button,
    TextField,
    FormControl,
    InputLabel,
    NativeSelect,
    useTheme,
    Select,
    IconButton,
  MenuItem
  } from "@mui/material";
  import { Formik } from "formik";
  import * as yup from "yup";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import Header from "../Components/Header";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { tokens } from "../theme";
  import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
  import { useEffect, useState } from "react";
  import * as React from "react";
  import Cookies from "js-cookie";
  import CryptoJS from "crypto-js";
  
  const NotificationsForm = () => {
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isTablet = useMediaQuery("(min-width:1175px");
    const colors = tokens(theme.palette.mode);
   const navigate = useNavigate();

    const getDecryptedToken = () => {
         const encryptedToken = Cookies.get("token");
         if (!encryptedToken) return null;
     
         const secretKey = '19092002'; 
         const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
         const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
     
         return decryptedToken || null;
       };
     
    
   
    
    const [notificationsData, setNotificationsData] = useState();
    const token = getDecryptedToken();
    
    


    const handleFormSubmit = async (values, actions) => {
      try {
           await axios.post(
            `${baseURL}/Notification/AddNotification`, 

              {
                notificationId: values.NotificationId,
              title: values.Title ,
              message: values.Message ,
              userId: values.UserId,
             
            }, 

            {
              headers: {
                Authorization: `Bearer ${token}`, 
              },
            }
           
          );
      navigate("/Notifications");
    } catch (error) {

     if (error.response.status == 400)
        {
                toast.error("Dicka shkoi keq, rishikoni te dhenat!");
        }
      if (error.response) {
        
        actions.resetForm();
        toast.error("Dicka shkoi keq! ");
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Error", error.message);
      }
    }
  };
  
    return (
      <Box m="20px">
        <ToastContainer hideProgressBar={true} autoClose={2000} />
        <Header title="Shto Notifikim" subtitle="Plotesoni te dhenat per notifikimin e ri" />
        <Link to="/notifications" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.primary[700], marginBottom: 2 }}
          >
            <KeyboardReturnOutlinedIcon />
            Tabela e notifikimeve
          </Button>
        </Link>

        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setValues,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                  <TextField
                  fullWidth
                  variant="filled"
                  label="ID"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="NotificationId"
                  value={values.NotificationId}
                  error={!!touched.NotificationId && !!errors.NotificationId}
                  sx={{ gridColumn: "span 2" }}
                />
                 <TextField
                  fullWidth
                  variant="filled"
                  label="Title"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="Title"
                  value={values.Title}
                  error={!!touched.Title && !!errors.Title}
                  sx={{ gridColumn: "span 2" }}
                />
                    <TextField
                  fullWidth
                  variant="filled"
                  label="Message"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="Message"
                  value={values.Message}
                  error={!!touched.Message && !!errors.Message}
                  sx={{ gridColumn: "span 2" }}
                />
                
            
                <TextField
                  fullWidth
                  variant="filled"
                  label="User ID"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="UserId"
                  value={values.UserId}
                  error={!!touched.UserId && !!errors.UserId}
                  sx={{ gridColumn: "span 2" }}
                />
               
                <Box sx={{ gridColumn: "span 4" }}>
                  {" "}
                  <hr
                    style={{
                      border: "none",
                      height: "2px",
                      backgroundColor: "white",
                      margin: "0",
                      padding: "0",
                    }}
                  />
                </Box>   
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" style={{ backgroundColor: colors.primary[700]}} variant="contained">
                Shto notifikimin
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
  };
  
  
  const checkoutSchema = yup.object().shape({
 
    // // Description: yup.string().required("Description is required!"),
    // NotificationId: yup.string().required("NotificationId is required!"),
    // Message: yup.string().required("Message is required!"),
    // Title: yup.string().required("Title is required!"),
    // UserId: yup.string().required("UserId Percentage is required!")
  });
  

  const initialValues = {
    NotificationId: "",
    Message: "",
    Title: "",
    UserId: "",
  };
  
  
  export default NotificationsForm;